var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2398_747)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14508 0C0.962543 0 0.00390625 0.958637 0.00390625 2.14118V11.8588C0.00390625 13.0414 0.962544 14 2.14508 14H11.8627C13.0453 14 14.0039 13.0414 14.0039 11.8588V2.14118C14.0039 0.958637 13.0453 0 11.8627 0H2.14508ZM9.07193 1.75C9.07176 2.35517 9.29151 2.93978 9.69026 3.395C10.4836 4.31083 11.5803 4.25833 11.5803 4.25833V6.06083C10.6804 6.06238 9.80284 5.78075 9.07193 5.25583V8.925C9.07193 10.7625 7.58443 12.25 5.75276 12.25C4.04359 12.25 2.43359 10.8675 2.43359 8.925C2.43359 6.93 4.19526 5.36667 6.20776 5.635V7.47833C5.21026 7.16917 4.24193 7.92167 4.24193 8.925C4.24193 9.765 4.93026 10.4417 5.75859 10.4417C6.15027 10.4416 6.52665 10.2896 6.80846 10.0175C7.09027 9.74553 7.25552 9.37476 7.26943 8.98333V1.75H9.07193Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2398_747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.adcf6fc5a887a7ea4b4646bff6693784.svg";
export { ForwardRef as ReactComponent };